import { render, staticRenderFns } from "./IntegrationDisabledButton.vue?vue&type=template&id=4d13797f&scoped=true&"
import script from "./IntegrationDisabledButton.vue?vue&type=script&lang=ts&"
export * from "./IntegrationDisabledButton.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationDisabledButton.vue?vue&type=style&index=0&id=4d13797f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13797f",
  null
  
)

export default component.exports